import React, {Component} from 'react';
import {VerbFetch} from '../VerbFetch';
import PropTypes from "prop-types";

class ActiveListener extends Component {

    static propTypes = {
        url: PropTypes.string,
        method: PropTypes.string,
        frequency: PropTypes.number,
        onSuccess: PropTypes.func,
        onFailure: PropTypes.func,
        isActivated: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            intervalId: null
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isActivated) {
            this.startListening();
        } else {
            this.stopListening();
        }
    }

    componentWillUnmount() {
        this.stopListening();
    }

    startListening = () => {

        if (!this.state.intervalId) {
            const intervalId = setInterval(() => {
                VerbFetch(this.props.url)
                    .then((response) => {
                        if (this.props.onSuccess) {
                            this.props.onSuccess(response);
                        }
                    })
                    .catch((error) => {
                        if (this.props.onFailure) {
                            this.props.onFailure(error);
                        }
                    });
            }, this.props.frequency);
            this.setState({ intervalId: intervalId});
        }
    };

    stopListening = () => {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
            this.setState({intervalId: null});
        }
    };

    render() {
        return null;
    }
};

export default ActiveListener;